<div *ngIf="letterAvatar.length > 0" class="bg-white border-primary-400 border-solid border-circle p-2 font-medium">
    {{letterAvatar | uppercase}}
</div>